import axios from 'axios';

const api = axios.create({
    baseURL: '/',
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
    },
});

export async function refreshCsrf() {
    await api.get('/sanctum/csrf-cookie');
}

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const url = error.config?.url || '';
        if (error.response?.status === 401 && !url.includes('/api/user')) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    },
);

export default api;
